import { getMeOrgFields } from '../Organization/OrganizationFields';
import { permissionFields } from '../RolePermissions/RolePermissionsFields';

export const userFields = `
  id
  email
  fullName
  firstName
  lastName
  status
  subscribedToMarketing
  username
  member {
    ownedPublishedDraftRooms
  }
`;

export const filterUserFields = `
  ${userFields}
  dealsCount
  ownedRoomsCount
  roomsCount
  teams {
    id
  }
`;

export const insightsUserFields = `
  ${filterUserFields}
  status
  userRoles {
    id
    organizationId
    role {
      id
      name
    }
  }
`;

export const roomOwnerUserFields = `
  ${userFields}
  linkedin
  phoneNumber
  photo
  member {
    jobTitle
    roleDescription
  }
`;

export const profileUserFields = `
  ${roomOwnerUserFields}
`;

export const collaboratorUserFields = `
  ${userFields}
  photo
  member {
    jobTitle
  }
`;

export const teamUserFields = `
  ${userFields}
  status
  teams {
    id
  }
`;

export const searchUserFields = `
  ${userFields}
  linkedin
  member {
    jobTitle
    roleDescription
  }
  phoneNumber
  photo
`;

export const userSettingsUserFields = `
  id
  email
  firstName
  fullName
  lastName
  linkedin
  phoneNumber
  photo
  roleName
  status
  username
  member {
    id
    jobTitle
    lastActivityAt
  }
  teams {
    id
    name
  }
`;

export const getMeUserFields = `
  id
  email
  firstName
  fullName
  isMtInternalUser
  isManager
  lastName
  linkedin
  marketoId
  pendingPasswordChange
  phoneNumber
  photo
  subscribedToMarketing
  member {
    fromName
    jobTitle
    monthlyRecapEmail
    roleDescription
    vendorUserId
    showInactives
  }
  username
  userRoles {
    id
    status
    role {
      name
    }
    rolePermissions {
      ${permissionFields}
    }
    organization {
      ${getMeOrgFields}
    }
  }
`;

export const userAccountFields = `
  id
  email
  firstName
  fullName
  lastName
  linkedin
  phoneNumber
  photo
  member {
    jobTitle
    roleDescription
    vendorUserId
  }
  username
`;
